import { useEffect, useState } from "react";

const FactsPDF = ({ data, pdftitle }) => {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (!data) return;

    try {
      // Remove potential base64 prefix
      const cleanBase64 = data.replace(/^data:application\/pdf;base64,/, "");

      // Convert base64 to binary buffer
      const byteCharacters = atob(cleanBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      // Create a Blob from the binary data
      const blob = new Blob([new Uint8Array(byteNumbers)], {
        type: "application/pdf",
      });

      // Create a temporary URL for the Blob
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);

      // Cleanup old blob URLs to prevent memory leaks
      return () => {
        URL.revokeObjectURL(url);
      };
    } catch (err) {
      console.error("PDF Blob creation failed:", err);
    }
  }, [data]);

  if (!pdfUrl) return <div>Loading PDF...</div>;

  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <iframe
        src={pdfUrl}
        title={pdftitle || "PDF Viewer"}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>
  );
};

export default FactsPDF;
